export function flattenCountryList(data) {
  if (!data || !data.length) return []
  const result = []
  data.forEach((item) => {
    result.push(...(item.data || []))
  })
  return result
}

export function parseCountryFromParams(params = {}) {
  if (params.country && params.country.countryNo != null) {
    return { ...params.country }
  }
  if (params.countryNo != null) {
    return {
      countryNo: params.countryNo,
      countryName: params.countryName,
      countryFlagUrl: params.countryFlagUrl,
      areaCode: params.areaCode,
      countryEnName: params.countryEnName
    }
  }
  return null
}

export function findCountryByAreaCode(countryList, areaCode) {
  if (!areaCode || !countryList || !countryList.length) return undefined
  const code = Number(areaCode)
  return countryList.find((item) => Number(item.areaCode) === code) || undefined
}

export function isInvalidAreaCode({ areaCode, countryList, countryListReady }) {
  if (!areaCode || !countryListReady) return false
  if (!countryList || !countryList.length) return false
  return !findCountryByAreaCode(countryList, areaCode)
}

export function resolveCountry({ selectedCountry, countryList, areaCode }) {
  if (selectedCountry && Number(selectedCountry.areaCode) === Number(areaCode)) {
    return selectedCountry
  }
  return findCountryByAreaCode(countryList, areaCode)
}

export function syncSelectedCountryOnAreaCodeChange(selectedCountry, countryList, areaCode) {
  if (selectedCountry && Number(selectedCountry.areaCode) === Number(areaCode)) {
    return selectedCountry
  }
  return findCountryByAreaCode(countryList, areaCode) || null
}



// WEBPACK FOOTER //
// ./src/utils/country.js